import { Injectable } from '@angular/core';
import { UtilsService } from '@ebw-monorepo/utils';
import { saveAs } from 'file-saver';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import {
  API_URLS,
  ApiUrlService
} from '../../../../../../../libs/ng-components/utils/src/lib/services/api-url.service';
import { UserManagerService } from '../../../services/user-manager.service';
import { Notification, NotificationType } from '../models/notification.model';

@Injectable()
export class NotificationService {
  public notifications$ = new BehaviorSubject<Notification[]>([]);
  public notificationsTypes$ = new BehaviorSubject<NotificationType[]>([]);
  public unreadNotificationCount$ = new BehaviorSubject<number>(0);

  private userId: string = '';
  private groupIds = [];

  // ------------------------------------------------------------------------------------

  constructor(
    private apiUrlService: ApiUrlService,
    private userManagerService: UserManagerService,
    private utilsService: UtilsService
  ) {
    this.userId = this.userManagerService.userId;
    this.groupIds = this.userManagerService.userInfo.groups.map((group) => group.id);
  }

  // ------------------------------------------------------------------------------------

  /**START Methods for get and set userId */
  getUserId() {
    return this.userId;
  }

  // ------------------------------------------------------------------------------------

  /**START Methods for get and set groups */
  getGroupIds() {
    return this.groupIds;
  }

  // ------------------------------------------------------------------------------------

  get notifications() {
    return this.notifications$.value;
  }

  // ------------------------------------------------------------------------------------

  async getNotifications() {
    const body = {
      user_id: this.userId,
      group_ids: this.groupIds,
      deleted: 0
    };
    try {
      const request = this.utilsService.getRequest(this.apiUrlService.createUrl(API_URLS.NOTIFICATION.GET), body);
      const response = await lastValueFrom(request);
      // se tutto ok
      if (response) {
        const notifications = response.map((n: Notification) => this.parseNotificationContent(n));
        this.notifications$.next(notifications);
        this.refreshCount();
        return;
      }
      // altrimenti
      console.warn('[NotificationService][getNotifications] ', response.message, response.traceback);
      this.notifications$.next([]);
    } catch (error) {
      this.notifications$.next([]);
      console.error('[NotificationService][getNotifications] ', error);
    }
  }

  // ------------------------------------------------------------------------------------

  parseNotificationContent(notification: Notification) {
    try {
      // controllo il tipo di notifica
      const isDownloadNotification = notification.type.value === 'link';
      if (!isDownloadNotification) {
        return notification;
      }
      // se è una notifica di tipo link, compongo il content con path e nome del file di cui fare il download
      const content = JSON.parse(notification.content);
      return { ...notification, content: content.content, name: content.name };
    } catch (error) {
      console.error('[NotificationService][parseNotificationContent]', error.message);
      return notification;
    }
  }

  // ------------------------------------------------------------------------------------

  read(id: string) {
    const isUnreadNotification = this.notifications.find((nl) => nl.id == id && nl.read.length == 0);
    if (!isUnreadNotification) {
      return;
    }

    let param = {
      user_id: this.userId,
      notification_id: id
    };

    return this.utilsService.postRequest(
      this.apiUrlService.createUrl(API_URLS.NOTIFICATION.READ),
      param,
      false,
      {},
      'application/json'
    );
  }

  // ------------------------------------------------------------------------------------

  refreshCount() {
    const count = this.notifications.filter((nl) => nl.read.length == 0).length;
    this.unreadNotificationCount$.next(count);
  }

  // ------------------------------------------------------------------------------------

  async downloadNotificationContent(notification: Notification) {
    const { content, name: filename } = notification;

    // let contentUrlProxy = this.mapService.proxyUrl + content.replace('?', '&');

    const blob = await lastValueFrom(this.utilsService.getFile(content, {}, { responseType: 'blob' }));
    return saveAs(blob, filename);
  }

  // ------------------------------------------------------------------------------------
}
